<script>
    import CallDialogLink from './CallDialogLink.vue';
    export default {
        mixins: [CallDialogLink],
        props: {
            confirmationMessage: {
                type: String,
                required: true
            }
        },
        mounted() {
            window.EventHandler.listen('confirm-dialog-' + this.id + '-called', responseObject => {
                window.EventHandler.fire('top-alert', {
                    id: 'alert-dialog-' + this.id,
                    message: this.confirmationMessage
                });
            });
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/src/components/Triggers/CallDialogConfirm.vue